if (!customElements.get('flamengo-cart-recommendations')) {
    customElements.define('flamengo-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('change', (event) => {
          const select = event.target.closest('[data-fcr-variant]');
          if (select) {
            event.stopPropagation();
            this.selectVariant(select);
          }
        });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-fcr-add]');
          if (button) {
            event.preventDefault();
            this.addVariant(button);
          }
        });
        this.addEventListener('toggle', (event) => {
          const opened = event.target;
          if (!opened.matches('[data-fcr-card]') || !opened.open) return;
          this.querySelectorAll('[data-fcr-card][open]').forEach((card) => {
            if (card !== opened) card.open = false;
          });
        }, true);
        this.querySelectorAll('[data-fcr-variant]').forEach((select) => {
          const options = Array.from(select.options).slice(1);
          const rank = (title) => {
            const value = title.split(' / ')[0].trim().toUpperCase();
            const sizes = ['XXXS','XXS','XS','S','M','L','XL','XXL','2XL','XXXL','3XL','4XL','5XL','6XL'];
            return /^\d+(\.\d+)?$/.test(value) ? Number(value) : sizes.indexOf(value) >= 0 ? sizes.indexOf(value) : 1000;
          };
          options.sort((a, b) => rank(a.textContent) - rank(b.textContent));
          options.forEach((option) => select.appendChild(option));
          this.selectVariant(select);
        });
        this.querySelectorAll('[data-fcr-add][data-default-variant]').forEach((button) => { button.disabled = false; });
      }

      selectVariant(select) {
        const card = select.closest('[data-fcr-card]');
        const option = select.selectedOptions[0];
        const button = card.querySelector('[data-fcr-add]');
        button.disabled = !select.value;
        button.dataset.variantId = select.value;
        button.dataset.quantity = option.dataset.quantity || '1';
        if (!select.value) return;
        card.querySelector('[data-fcr-price]').textContent = option.dataset.price;
        const creditAmount = card.querySelector('[data-loyalty-amount]');
        if (creditAmount) creditAmount.textContent = option.dataset.loyaltyAmount;
        const creditFrom = card.querySelector('[data-loyalty-from]');
        if (creditFrom) creditFrom.hidden = true;
        card.querySelector('[data-fcr-product-link]').href = option.dataset.url;
        const image = card.querySelector('[data-fcr-image]');
        if (image) {
          let source = { url: option.dataset.image, alt: option.dataset.imageAlt };
          if (card.dataset.hasColor === 'true') {
            let data = { map: {}, images: {} };
            try { data = JSON.parse(card.querySelector('[data-fcr-media]')?.textContent || '{}'); } catch (_) {}
            const map = data.map || {};
            const color = option.dataset.color;
            let mediaId = Number(option.dataset.mediaId);
            if (!mediaId) {
              const sibling = Array.from(select.options).find((candidate) => candidate.dataset.color === color && Number(candidate.dataset.mediaId));
              mediaId = Number(sibling?.dataset.mediaId) || 0;
            }
            const correction = map.__nativeOverrides?.[color];
            if (Array.isArray(map.__missingColors) && map.__missingColors.includes(color)) {
              mediaId = 0;
            } else if (mediaId && correction && Array.isArray(correction.from) && correction.from.some((id) => Number(id) === mediaId)) {
              mediaId = Number(correction.to) || 0;
            } else if (!mediaId) {
              mediaId = Number(map[color]) || 0;
            }
            source = data.images?.[String(mediaId)] || {};
          }
          if (source.url) {
            image.src = source.url;
            image.removeAttribute('srcset');
            image.alt = source.alt || '';
            image.hidden = false;
          } else if (card.dataset.hasColor === 'true') {
            image.hidden = true;
          }
          const note = card.querySelector('[data-fcr-image-note]');
          if (note) note.hidden = !image.hidden;
        }
        this.querySelector('[data-fcr-status]').textContent = '';
      }

      async addVariant(button) {
        if (this.busy || button.disabled || !button.dataset.variantId) return;
        this.busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = this.dataset.adding;
        const status = this.querySelector('[data-fcr-status]');
        status.textContent = '';
        let added = false;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variantId), quantity: Number(button.dataset.quantity) || 1 }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
          added = true;
          if (this.dataset.context === 'page') {
            window.location.reload();
            return;
          }
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function' || !result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          drawer.renderContents(result);
          drawer.classList.remove('is-empty');
          const liveStatus = drawer.querySelector('[data-fcr-status]') || drawer.querySelector('#CartDrawer-LiveRegionText');
          if (liveStatus) liveStatus.textContent = this.dataset.added;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'flamengo-cart-recommendations' } }));
          window.setTimeout(() => {
            const closeButton = drawer.querySelector('.drawer__close');
            closeButton?.focus({ preventScroll: true });
          }, 80);
        } catch (error) {
          if (added) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          status.textContent = error.message || this.dataset.error;
          button.disabled = false;
          button.textContent = this.dataset.add;
          button.removeAttribute('aria-busy');
          this.busy = false;
        }
      }
    });
  }
